import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { type DependencyList, useMemo, useRef } from 'react';

const useMemoDeep = <T>(callback: () => T, plainDeps: DependencyList) => {
  const deps = useRef<DependencyList>();
  if (!isEqual(deps.current, plainDeps)) {
    deps.current = cloneDeep(plainDeps);
  }
  return useMemo(callback, [deps.current]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useMemoDeep;
